import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
//import { createDevice } from "../services/createDevice";
import Box from "@mui/material/Box";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import Select from "react-select";
import { environment } from "../../../environment";
// import Dropdown from "./Dropdown";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import Multiselect from "multiselect-react-dropdown";
import { Redirect } from "react-router-dom";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
// import { useEffect } from "react";
import Container, { TableContainer, TextField } from "@mui/material";
import NavbarNew from "../../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AssignDeviceToCustomer = ({ history }) => {
  const [room, setRoom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [defaultProfileDetails, setDefaultProfileId] = useState("");
  const [dap_category, setCategory] = useState([]);
  const [device_access_token, setAccessToken] = useState("");
  const [devicelabel, setdevicelabel] = useState("");
  const [devicecategory, setcategoty] = useState("");
  const [deviceversion, setdeviceversion] = useState("");
  const [accesstoken, setaccesstoken] = useState("");
  const [device_alias, setAlias] = useState("");
  const [device_version, setVersion] = useState("");
  const [dap_customers, setDapCustomers] = useState([]);
  const [dap__device_details, setDevicedetails] = useState({});
  const [customerdetails, setcustomerdetails] = useState({});
  const [product_categories, setproductcategories] = useState([]);
  const [aliasErrors, setAliasErrors] = useState({});
  const [display_suggestion, setDisplaySuggestion] = useState([
    {
      display: "none",
      zIndex: "-999",
    },
  ]);

  const [inputfields, setInputFields] = useState([
    {
      deviceName: "",
      deviceLabel: "",
      deviceVersion: "",
      deviceCategory: "",
      AccessToken: "",
      deviceType: "",
      deviceTypeId: "",
      // isInstalled: false,
      // shipmentIdMongo: "",
    },
  ]);

  const getDefaultProfileName = async (id) => {
    console.log(id);
    await axios
      .post(
        environment.dap_url + `external_api/getDefaultProfileName`,
        { tenant_id: id },
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        console.log(res.data.profileId);
        setDefaultProfileId(res.data.profileId);
      })
      .catch(function (error) {
        console.log(error);
        window.alert("something wrong Happened");
      });
  };
  useEffect(() => {
    let userDetails = localStorage.getItem("userDetails");
    userDetails = JSON.parse(userDetails);
    let user = JSON.parse(localStorage.getItem("user"));
    console.log(userDetails.data.id.id);
    let tenantDetails = JSON.parse(localStorage.getItem("tenantDetails"));
    // getDevicesByPartner(userDetails.data.id.id);

    getDefaultProfileName(tenantDetails.data.id.id);
    axios
      .post(environment.dap_url + "users/getUsersByfilters", {
        filters: {
          userType: "CUSTOMER_USER",
          parentId: user._id,
          isDeleted: false,
          isActive: true,
        },
      })
      .then((res) => {
        console.log(res.data);
        // setLoader(false);
        setDapCustomers(res.data);
        // customers_array = res.data;
        // console.log(customers_array);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(environment.apiUrl + `customers?pageSize=1000&page=0`, {
    //     headers: {
    //       "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //     },
    //   })

    //   .then((res) => {
    //     console.log(res.data.data);
    //     setDapCustomers(res.data.data);
    //   })
    //   .catch(function (error) {
    //     window.alert(error.message);
    //   });
  }, []);

  const getDevicesByPartner = (id) => {};

  const FindDevice = (label) => {
    setdevicelabel(label);
    let user = JSON.parse(localStorage.getItem("user"));
    axios
      .get(
        environment.dap_url +
          `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
          label +
          "&partnerId=" +
          user._id
      )
      .then((res) => {
        setDevicedetails(res.data);
        console.log(res);
      })
      .catch(function (error) {
        console.log(error.message);
      });
  };

  const submit = async () => {
    if (isError == true) return;
    console.log(customerdetails);
    console.log(dap__device_details);
    if (dap__device_details == undefined) {
      MySwal.fire({
        title: "The item is not present in your inventory",
        icon: "error",
        type: "error",
      }).then((res) => {
        setdevicelabel("");
        setdeviceversion("");
        setaccesstoken("");
        setcategoty("");
      });
    } else if (dap__device_details.isAvailableForAssign == false) {
      MySwal.fire({
        title: "This item is already assigned to a customer",
        icon: "error",
        type: "error",
      }).then((res) => {
        setdevicelabel("");
        setdeviceversion("");
        setaccesstoken("");
        setcategoty("");
      });
    } else if (dap__device_details.statusText == "Device Damaged") {
      MySwal.fire({
        title: "This device is damaged",
        icon: "error",
        type: "error",
      }).then((res) => {
        setdevicelabel("");
        setdeviceversion("");
        setaccesstoken("");
        setcategoty("");
      });
    } else {
      let tenantDetails = localStorage.getItem("tenantDetails");
      tenantDetails = JSON.parse(tenantDetails);
      console.log(tenantDetails.data.id.id);

      await axios
        .post(environment.dap_url + "external_api/assignDeviceToCustomer", {
          device_details: dap__device_details,
          profileId: defaultProfileDetails,
          customerId: customerdetails.value,
          tenantId: tenantDetails.data.id.id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.forFirstTime == false) {
            axios
              .put(
                environment.dap_url +
                  "updateWithObjId/" +
                  res.data.assignDetails.id.id,
                {
                  deviceOwnerId: res.data.customerId,
                  device_alias: device_alias,
                }
              )
              .then((res) => {
                console.log(res);
                // getAllTenantdevices();
                MySwal.fire({
                  title: <p>Device assigned successfully</p>,
                  type: "success",
                });
                history.push("/partner-devices");
              })
              .catch((err) => {
                console.log(err);
                MySwal.fire({
                  title: <p>{err?.response?.data?.message}</p>,
                  type: "error",
                });
              });
          } else {
            updatedeviceinMongo(
              res.data.assignDetails.accessToken,
              res.data.customerId,
              res.data.deviceDetails,
              res.data.assignDetails.device,
              "",
              device_alias
            );
          }
        })
        .catch((err) => {
          MySwal.fire({
            title: (
              <p>
                {err?.response?.data?.message || "Device couldn't be assigned"}
              </p>
            ),
            type: "error",
          });
        });

      // await axios
      //   .get(
      //     environment.dap_url +
      //       "dapDevice/isAssignedToCustomer?deviceLabel=" +
      //       dap__device_details.deviceLabel+"&tenantId="+tenantDetails.data.tenantId.id
      //   )
      //   .then(async (deviceRes) => {
      //     console.log(deviceRes);
      //     if(deviceRes.status == 200){
      //       if (deviceRes.data.available == true) {
      //         MySwal.fire({
      //           title: "Are you sure?",
      //           icon: "warning",
      //           showCancelButton: true,
      //           confirmButtonText: "Yes",
      //         }).then(async function (result) {
      //           if (result.isConfirmed) {
      //             await axios
      //               .post(
      //                 environment.apiUrl + "device",
      //                 {
      //                   name: dap__device_details.deviceLabel,
      //                   label: dap__device_details.deviceLabel,
      //                   deviceProfileId: {
      //                     entityType: "DEVICE_PROFILE",
      //                     // id: "4bf465c0-e922-11eb-aeab-6338f3fa1c68",
      //                     id: defaultProfileDetails,
      //                   },
      //                   additionalInfo: {
      //                     gateway: false,
      //                     overwriteActivityTime: false,
      //                     description: dap__device_details.description,
      //                   },
      //                   // customerId: null,
      //                   // transportType: dap_transport_type,
      //                   type: "DEFAULT",
      //                 },
      //                 {
      //                   headers: {
      //                     "X-Authorization":
      //                       "Bearer " + localStorage.getItem("token"),
      //                   },
      //                 }
      //               )
      //               .then((res) => {
      //                 console.log("ankit");
      //                 console.log(res.data);
      //                 if (res.data != undefined) {
      //                   console.log("device created");
      //                   console.log(customerdetails.value);
      //                   console.log(dap__device_details);
      //                   assignDevice(
      //                     customerdetails.value,
      //                     dap__device_details,
      //                     res.data
      //                   );
      //                 } else {
      //                   console.log("device already present");
      //                   console.log(customerdetails.value);
      //                   console.log(dap__device_details);
      //                   assignDeviceToOtherUser(
      //                     customerdetails.value,
      //                     dap__device_details
      //                   );
      //                 }
      //               })
      //               .catch((err) => {
      //                 console.log(err, "qwerty");
      //                 // console.log(err.status, "qwerty");
      //                 // console.log(err.response, "qwerty");

      //                 // MySwal.fire({
      //                 //   title: <p>{err?.response?.data?.message}</p>,
      //                 //   type: "error",
      //                 // });

      //                 // if (
      //                 //   err?.response?.data?.message ===
      //                 //   "Device with such name already exists!"
      //                 // ) {
      //                 //   assignDeviceToOtherUser(customerdetails.value, dap__device_details);
      //                 // } else {
      //                 //   MySwal.fire({
      //                 //     title: <p>{err.response.data.message}</p>,
      //                 //     type: "error",
      //                 //   });
      //                 // }
      //               });
      //           }
      //         });

      //         // alert(customerdetails.value);
      //       } else {
      //         MySwal.fire({
      //           title: "Device is already assigned to a customer",
      //           icon: "error",
      //         });
      //       }
      //     }else if(deviceRes.status == 201){
      //       MySwal.fire({
      //         title: "Device is not present in your inventory",
      //         icon: "error",
      //       });
      //     }else{
      //       MySwal.fire({
      //         title: "An error occcured",
      //         icon: "error",
      //       });
      //     }

      //   });
    }
  };

  const scan = (value) => {
    const myarray = value.split("|");
    if (myarray.length == 5) {
      let user = JSON.parse(localStorage.getItem("user"));
      setcategoty(myarray[0]);
      setdevicelabel(myarray[1]);
      setdeviceversion(myarray[2]);
      setaccesstoken(myarray[3]);
      axios
        .get(
          environment.dap_url +
            `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
            myarray[1] +
            "&partnerId=" +
            user._id
        )
        .then((res) => {
          setDevicedetails(res.data);
          //check for device is assign to the customer or not

          console.log(res);
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } else {
      setcategoty(value);
    }
    console.log(myarray);

    // setcategoty(value);
  };

  const updatedeviceinMongo = async (
    accessToken,
    c_id,
    deviceData,
    tbDeviceData,
    deviceUserDetails,
    device_alias
  ) => {
    console.log(deviceData);
    await axios
      .put(environment.dap_url + "assignToCustomer/" + deviceData._id, {
        deviceId: tbDeviceData.id.id,
        device_alias: device_alias,
        deviceProfileId: tbDeviceData.deviceProfileId.id,
        tenantId: deviceData.tenantId,
        deviceProfileName: deviceData.deviceProfileName,
        deviceOwnerId: c_id,
        accessToken: accessToken,
      })
      .then((res) => {
        // getAllTenantdevices();
        console.log(res.data);
        MySwal.fire({
          title: <p>Device has been assigned successfully</p>,
          type: "success",
        }).then((result) => {
          history.push("/partner-devices");
        });
      })
      .catch((err) => {
        console.log(err, "zxcvbnm");
        MySwal.fire({
          title: <p>Failed to assign device.</p>,
          type: "error",
        });
      });
  };

  const FindAlias = (name) => {
    setAlias(name);
    setAliasErrors({});
    setIsError(false);
    axios
      .get(environment.dap_url + "devicealias/isavailable?alias=" + name)
      .then((res) => {
        if (res.data == false) {
          aliasErrors.err = "* This alias is Reserved";
          setAliasErrors(aliasErrors);
          setIsError(true);
        }
      });
  };
  // const getAllTenantdevices = async () => {
  //   let userDetails = localStorage.getItem("userDetails");
  //   userDetails = JSON.parse(userDetails);
  //   await axios
  //     .get(
  //       environment.dap_url +
  //         `getDevicesByTenantId/` +
  //         userDetails.data.tenantId.id
  //     )

  //     .then((res) => {
  //       console.log(res.data);
  //       setDevices(res.data.reverse());
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };
  return (
    <div>
      <div className="container-fluid">
        <NavbarNew />
        <Link to="/partner-devices" className="btn btn-light my-3">
          Go Back
        </Link>
      </div>

      <div className="container col-md-12">
        <div className="row ">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card p-5">
              <h1 className="text-center">Assign Customer</h1>
              <Form>
                <div className="row">
                  <div className="col-md-4">
                    <Form.Group controlId="consignee">
                      <Form.Label>Customer</Form.Label>
                      <Select
                        options={dap_customers.map((dap_customer) => ({
                          id: dap_customer.userId,
                          value: dap_customer.customerId,
                          label: dap_customer.organization,
                        }))}
                        onChange={(e) => setcustomerdetails(e)}
                        // defaultValue={dap_deviceList[0].name}
                        defaultValue="hi there"
                        placeholder={"Set Customer"}
                      />
                    </Form.Group>
                  </div>
                  {/* <div className="col-md-4">
                    <Form.Group controlId="">
                      <Form.Label>Room</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Room"
                        value={room}
                        onChange={(e) => setRoom(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </div> */}
                  {/* <div className="col-md-4">
                    <input type="checkbox" style={{ marginTop: 24 }} />
                    Is Device Damaged ?
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <Form.Group controlId="">
                      <Form.Label>Device Category</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Category"
                        value={devicecategory}
                        onChange={(e) => scan(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group controlId="">
                      <Form.Label>Device Lable</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Label"
                        value={devicelabel}
                        onChange={(e) => FindDevice(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group controlId="">
                      <Form.Label>Device Alias</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="alias name"
                        value={device_alias}
                        onChange={(e) => FindAlias(e.target.value)}
                      ></Form.Control>
                      <div>
                        {Object.keys(aliasErrors).map((key) => {
                          return (
                            <div class="my-2" style={{ color: "red" }}>
                              {aliasErrors[key]}
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group controlId="">
                      <Form.Label>Version</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="version"
                        value={deviceversion}
                        onChange={(e) => setdeviceversion(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group controlId="">
                      <Form.Label>Access Token</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Token"
                        value={accesstoken}
                        onChange={(e) => setaccesstoken(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                </div>
              </Form>
              <div className="col-md-12">
                <Button
                  className="success"
                  style={{ float: "right", margin: 10 }}
                  onClick={() => submit()}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignDeviceToCustomer;
